import React, { Component } from 'react';
import TagManager from 'react-gtm-module';
import {Link} from 'react-router-dom';
import Tooltip  from 'rc-tooltip';
import GuestFrame from './GuestFrame.js';

export default class Recover extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			errors: []
		};

		this.gtmTimeout = null;
		this.sendCustomEventGTM({event:"sv_recover_visita"});
	}
	componentWillUnmount() {
		clearTimeout(this.gtmTimeout);
	}

	sendCustomEventGTM({event, metadata={}}){
		if (!event) return;
		const { email, errors } = this.state;
		TagManager.dataLayer({ 
			dataLayer:{ event, metadata: { email, errors, ...metadata} } 
		});
	}

	emailValid() {
		const regex = /^(([a-zA-Z0-9\._-]+)@([a-zA-Z0-9-]+)\.([a-zA-Z]{2,4}))$/;
		const isValid= regex.test(this.state.email);
		if(!isValid) this.setState({errors: {email:'Formato de correo invalido'}});

		this.trackFieldInteraction();

		return isValid;
	}
	sendForm() {
		this.sendCustomEventGTM({event:"sv_recover_click_restablecer"});
		if(!this.emailValid()) return;

		this.setState({loading: true});
		this.props.doRecover(this.state.email, (error, result) => {
			this.setState({loading: false});

			this.sendCustomEventGTM({ event:"sv_recover_click_restablecer", metadata:{request_results:{error,result}} });

			if(error) return this.setState({errors: error.errors});
			if(result.status === 'error'){
				var errorForm = {
					'email': result.message
				}
				this.setState({errors: errorForm});
			}
		}, this.props.isEmpresas);
	}
	deleteFormError(field_name) {
		var formErrors = {...this.state.errors};
		delete formErrors[field_name];
		this.setState({errors: formErrors})
	}
	trackFieldInteraction() {
		clearTimeout(this.gtmTimeout);
		this.gtmTimeout = setTimeout(() => {
			this.sendCustomEventGTM({ event:"sv_recover_interaccion_campos" });
		}, 1000);
	}

	render() {
		return (
			<GuestFrame>
				<div className="login-container">
					<div className="background-flame">
						<h2 className="margin-bottom-40">Olvidé mi Contraseña</h2>
						<p className="color-white">Ingresa tu correo electrónico y te enviaremos las instrucciones para restaurar tu contraseña.</p>
						<div className="login-field-container recover-mail">
							<p>Email</p>
							<Tooltip placement="bottom" visible={this.state.errors && this.state.errors.email ? true : false}
				 			overlay={<span>{this.state.errors ? this.state.errors.email : ""}</span>}>
						 		<input
								value={this.state.email}
								onChange={(e) => {
									this.setState({email: e.target.value}); 
									this.deleteFormError("email");
									this.trackFieldInteraction();
								}} />
							</Tooltip>
				 		</div>
				 		<div className="login-submit-button-container recover-link">
							<button className="login-submit-button margin-top-10" onClick={() => this.sendForm()}>RESTABLECER CONTRASEÑA</button>
						</div>
						<div className="link-white">
							<Link to={"/login"} onClick={()=>this.sendCustomEventGTM({event:"sv_recover_click_volver"})}>
								<span>Volver</span>
							</Link>
						</div>
					</div>
				</div>
			</GuestFrame>

		);
	}
}
